import React, { useState, useRef, useEffect } from 'react';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import './ColorPicker.scss'; // Стили ниже

const ColorPicker = ({
  initialColor = '#3b82f6',
  onChange,
  showInput = true,
  position = 'bottom-start',
  buttonText = 'Выбрать цвет',
  buttonClassName = '',
  pickerClassName = ''
}) => {
  const [color, setColor] = useState(initialColor);
  const [isOpen, setIsOpen] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const pickerRef = useRef(null);

  // Обработка клика вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      updatePickerPosition();
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Позиционирование пикера
  const updatePickerPosition = () => {
    if (!buttonRef.current) return;

    const buttonRect = buttonRef.current.getBoundingClientRect();
    const pickerWidth = 200;
    const pickerHeight = 200;
    const offset = 8;

    let top = buttonRect.bottom + offset;
    let left = buttonRect.left;

    // Автоматическая корректировка позиции
    if (position.includes('bottom')) {
      top = buttonRect.bottom + offset;
    }
    if (position.includes('top')) {
      top = buttonRect.top - pickerHeight - offset;
    }
    if (position.includes('end')) {
      left = buttonRect.right - pickerWidth;
    }
    if (position.includes('start')) {
      left = buttonRect.left;
    }
    if (position.includes('center')) {
      left = buttonRect.left + (buttonRect.width - pickerWidth) / 2;
    }

    // Проверка выхода за границы окна
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (left + pickerWidth > viewportWidth) {
      left = viewportWidth - pickerWidth - offset;
    }
    if (left < 0) {
      left = offset;
    }
    if (top + pickerHeight > viewportHeight) {
      top = buttonRect.top - pickerHeight - offset;
    }
    if (top < 0) {
      top = buttonRect.bottom + offset;
    }

    setPickerPosition({ top, left });
  };

  const handleColorChange = (newColor) => {
    setColor(newColor);
    if (onChange) {
      onChange(newColor);
    }
  };

  const togglePicker = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (newState) {
      setTimeout(updatePickerPosition, 0);
    }
  };

  const handleButtonClick = () => {
    togglePicker();
  };

  return (
    <div className="color-picker-container">
      <button
        ref={buttonRef}
        type="button"
        className={`color-picker-button ${buttonClassName}`}
        onClick={handleButtonClick}
        style={{ backgroundColor: color }}
        aria-label="Выбрать цвет"
        title={color}
      >
        <span className="button-text">{buttonText}</span>
        <span className="color-preview" style={{ backgroundColor: color }} />
      </button>

      {isOpen && (
        <div
          ref={pickerRef}
          className={`color-picker-popup ${pickerClassName}`}
          style={{
            position: 'fixed',
            top: `${pickerPosition.top}px`,
            left: `${pickerPosition.left}px`,
            zIndex: 1000,
          }}
        >
          <HexColorPicker color={color} onChange={handleColorChange} />
          
          {showInput && (
            <div className="color-input-container">
              <HexColorInput
                color={color}
                onChange={handleColorChange}
                prefixed
                className="color-input"
              />
              <div className="color-display" style={{ backgroundColor: color }} />
            </div>
          )}

          <div className="color-picker-actions">
            <button
              type="button"
              onClick={() => handleColorChange(initialColor)}
              className="reset-button"
            >
              Сбросить
            </button>
            <button
              type="button"
              onClick={togglePicker}
              className="close-button"
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;